export const PACKAGE_CLASSNAME = 'header-package';
export const HERO_SECTION_SELECTOR = '.logo_maker_perseus .hero-section';
export const LEGACY_HERO_SECTION_SELECTOR = '.makers_experience_perseus .hero-section';
export const HERO_SECTION_ID = 'makers-experience-buyer-lp-hero-section';
